<template>
  <div class="content-container">
    <transition name="fade">
      <div class="report-page" v-if="Report">
        <div class="sign-container" v-if="sucess">
          <div class="sucess-ing">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="70px"
              height="70px"
            >
              <path
                fill-rule="evenodd"
                fill="rgb(119, 198, 75)"
                d="M34.984,69.71 C16.173,69.71 0.924,53.821 0.924,35.10 C0.924,16.194 16.173,0.949 34.984,0.949 C53.794,0.949 69.43,16.194 69.43,35.10 C69.43,53.821 53.794,69.71 34.984,69.71 ZM34.976,10.629 C21.519,10.629 10.608,21.535 10.608,34.999 C10.608,48.454 21.519,59.369 34.976,59.369 C48.435,59.369 59.345,48.454 59.345,34.999 C59.345,21.535 48.435,10.629 34.976,10.629 ZM34.871,46.798 C34.796,46.885 34.738,46.980 34.655,47.63 C33.934,47.784 33.44,48.232 32.113,48.410 C30.551,48.731 28.864,48.290 27.652,47.78 C27.504,46.930 27.388,46.762 27.262,46.600 L19.734,39.72 C17.820,37.158 17.820,34.55 19.734,32.141 C21.648,30.227 24.751,30.227 26.665,32.141 L31.158,36.634 L42.866,24.926 C44.782,23.10 47.888,23.10 49.804,24.926 C51.720,26.842 51.720,29.949 49.804,31.865 L34.871,46.798 Z"
              />
            </svg>
          </div>
          <div class="sign-title" :class="{ zh: $i18n.locale == 'zh' }">
            {{ this.$i18n.locale == "zh" ? "发送成功!" : "REQUEST RECEIVED!" }}
          </div>
          <div class="sign-text" v-if="this.$i18n.locale == 'zh'">
            报告发送成功，我们将尽快处理！
          </div>
          <div class="sign-text" v-if="this.$i18n.locale == 'en'">
            The work order has been sent successfully,<br />
            we will deal with it as soon as possible!
          </div>
          <div class="submit-box">
            <a class="sub">
              <div id="btn" @click="backHome()">
                {{ this.$i18n.locale == "zh" ? "返回" : "BACK" }}
              </div>
            </a>
          </div>
          <!-- <div class="bottom-timer">
                    还有 <a class="greener" href="">{{ time - 1 }}</a> 秒后跳转
                </div> -->
        </div>
        <div class="innerbox" v-else>
          <div class="select-box">
            <div class="txt-title">{{ $t("m.server.reportTitle") }}</div>
            <div class="txt-small">
              {{ $t("m.server.reportTxt") }}
            </div>
            <div class="box">
              <div class="txt-title">{{ $t("m.server.reportOne") }}</div>
              <el-select
                v-model="services"
                placeholder=" "
                :popper-append-to-body="false"
                ref="multiSelect"
                @click="hooseCustom()"
              >
                <el-option
                  v-for="(item, index) in servicesData"
                  :key="index"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <div class="alert" v-if="alert">
                <svg
                  data-v-cc53d074=""
                  data-v-700d1935=""
                  version="1.1"
                  id="图层_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 22 22"
                  xml:space="preserve"
                  style="
                    width: 14px;
                    fill-rule: evenodd;
                    clip-rule: evenodd;
                    fill: rgb(244, 109, 91);
                    margin: 2px 4px -2px 0;
                  "
                >
                  <g data-v-cc53d074="" data-v-700d1935="">
                    <path
                      data-v-cc53d074=""
                      data-v-700d1935=""
                      d="M11,0C4.9,0,0,4.9,0,11s4.9,11,11,11s11-4.9,11-11S17.1,0,11,0z M11,19.1c-4.5,0-8.1-3.6-8.1-8.1
		S6.5,2.9,11,2.9s8.1,3.6,8.1,8.1S15.5,19.1,11,19.1z"
                      class="st0"
                    ></path>
                    <path
                      data-v-cc53d074=""
                      data-v-700d1935=""
                      d="M11,12.3c0.9,0,1.6-0.7,1.6-1.6V6.1c0-0.9-0.7-1.6-1.6-1.6S9.4,5.2,9.4,6.1v4.6C9.4,11.6,10.1,12.3,11,12.3z"
                      class="st0"
                    ></path>
                    <circle
                      data-v-cc53d074=""
                      data-v-700d1935=""
                      cx="11"
                      cy="15.2"
                      r="1.9"
                      class="st0"
                    ></circle>
                  </g>
                </svg>
                {{ $t("m.login.alert") }}
              </div>
            </div>
            <div class="box">
              <div class="txt-title">{{ $t("m.server.reportTwo") }}</div>
              <div class="input-box">
                <textarea rows="4" v-model="description"> </textarea>
              </div>
            </div>
          </div>
          <span class="close" @click="closeRep()">
            {{ $t("m.server.close") }}</span
          >
          <span class="post" @click="post()"> {{ $t("m.server.submit") }}</span>
        </div>
      </div>
    </transition>
    <BannerSearch
      class="win-t"
      :title="'猛兽派对服务器状态'"
      v-if="$i18n.locale == 'zh'"
    ></BannerSearch>
    <BannerSearch
      class="mob-t"
      :title="'服务器状态'"
      v-if="$i18n.locale == 'zh'"
    ></BannerSearch>
    <BannerSearch
      class="win-t"
      :title="'Party Animals Service Status'"
      v-if="$i18n.locale == 'en'"
    ></BannerSearch>
    <BannerSearch
      class="mob-t"
      :title="'SERVICE STATUS'"
      v-if="$i18n.locale == 'en'"
    ></BannerSearch>
    <div class="content">
      <div class="content-box">
        <div class="text-box">
          <div class="title-box">
            <div class="title" v-if="code == 0">
              <svg
                version="1.1"
                id="图层_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 22 22"
                style="
                  enable-background: new 0 0 22 22;
                  fill-rule: evenodd;
                  clip-rule: evenodd;
                  fill: #77c64b;
                  width: 34px;
                  height: 34px;
                "
                xml:space="preserve"
              >
                <path
                  class="st0"
                  d="M11,0C4.9,0,0,4.9,0,11c0,6.1,4.9,11,11,11s11-4.9,11-11C22,4.9,17.1,0,11,0z M15.8,10L11,14.8
                                                                            	c0,0-0.1,0.1-0.1,0.1c-0.3,0.3-0.7,0.5-1.1,0.5c-0.4,0-0.8-0.2-1.1-0.5c0,0-0.1-0.1-0.1-0.1l-2.5-2.5c-0.6-0.6-0.6-1.6,0-2.2
                                                                            	c0.6-0.6,1.6-0.6,2.2,0l1.5,1.5l3.8-3.8c0.6-0.6,1.6-0.6,2.2,0C16.4,8.4,16.4,9.4,15.8,10z"
                />
              </svg>
              {{ $t("m.server.running") }}
            </div>
            <div class="title" v-if="code == 1">
              <svg
                data-v-47a3d9c5=""
                version="1.1"
                id="图层_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 21.8 19.9"
                xml:space="preserve"
                style="width: 34px; height: 34px"
              >
                <path
                  data-v-47a3d9c5=""
                  d="M7.4,2c1.5-2.7,5.4-2.7,6.9,0l6.9,11.9c1.5,2.7-0.4,6-3.5,6H4c-3.1,0-5-3.3-3.5-6L7.4,2z"
                  class="st0"
                  style="fill: rgb(255, 185, 64)"
                ></path>
                <path
                  data-v-47a3d9c5=""
                  d="M11,9.3c0.9,0,1.6,0.7,1.6,1.6v4.6c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6v-4.6C9.4,10,10.1,9.3,11,9.3z
                                                                            	"
                  class="st1"
                  style="
                    fill-rule: evenodd;
                    clip-rule: evenodd;
                    fill: rgb(63, 65, 65);
                  "
                ></path>
                <path
                  data-v-47a3d9c5=""
                  d="M11,8.3c1,0,1.9-0.9,1.9-1.9c0-1-0.9-1.9-1.9-1.9c-1,0-1.9,0.9-1.9,1.9C9.1,7.5,10,8.3,11,8.3z"
                  class="st1"
                  style="
                    fill-rule: evenodd;
                    clip-rule: evenodd;
                    fill: rgb(63, 65, 65);
                  "
                ></path>
              </svg>
              {{ $t("m.server.limit") }}
            </div>
            <div class="title" v-if="code == 2">
              <svg
                data-v-47a3d9c5=""
                version="1.1"
                id="图层_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 22 22"
                xml:space="preserve"
                style="
                  width: 34px;
                  height: 34px;
                  fill-rule: evenodd;
                  clip-rule: evenodd;
                  fill: rgb(244, 109, 91);
                "
              >
                <path
                  data-v-47a3d9c5=""
                  d="M11,0C4.9,0,0,4.9,0,11c0,6.1,4.9,11,11,11c6.1,0,11-4.9,11-11C22,4.9,17.1,0,11,0z M9.4,6.1
                                                                            	c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6v4.6c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6V6.1z M11,17.1
                                                                            	c-1,0-1.9-0.9-1.9-1.9c0-1,0.9-1.9,1.9-1.9c1,0,1.9,0.9,1.9,1.9C12.9,16.2,12,17.1,11,17.1z"
                  class="st0"
                ></path>
              </svg>
              {{ $t("m.server.bigerror") }}
            </div>
            <div class="text">
              {{ $t("m.server.update") }}
            </div>
          </div>
          <div class="alert-box">
            <div class="title">
              {{ $t("m.server.status") }}
            </div>
            <div class="text-with-icon">
              <svg
                version="1.1"
                id="图层_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 22 22"
                style="
                  enable-background: new 0 0 22 22;
                  fill-rule: evenodd;
                  clip-rule: evenodd;
                  fill: #77c64b;
                  width: 22px;
                  height: 22px;
                "
                xml:space="preserve"
              >
                <path
                  class="st0"
                  d="M11,0C4.9,0,0,4.9,0,11c0,6.1,4.9,11,11,11s11-4.9,11-11C22,4.9,17.1,0,11,0z M15.8,10L11,14.8
                                                                            	c0,0-0.1,0.1-0.1,0.1c-0.3,0.3-0.7,0.5-1.1,0.5c-0.4,0-0.8-0.2-1.1-0.5c0,0-0.1-0.1-0.1-0.1l-2.5-2.5c-0.6-0.6-0.6-1.6,0-2.2
                                                                            	c0.6-0.6,1.6-0.6,2.2,0l1.5,1.5l3.8-3.8c0.6-0.6,1.6-0.6,2.2,0C16.4,8.4,16.4,9.4,15.8,10z"
                />
              </svg>
              {{ $t("m.server.runningsmall") }}
            </div>
            <div class="text-with-icon">
              <svg
                version="1.1"
                id="图层_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 21.8 19.9"
                style="
                  enable-background: new 0 0 21.8 19.9;
                  height: 22px;
                  width: 22px;
                "
                xml:space="preserve"
              >
                <path
                  class="st0"
                  style="fill: #ffb940"
                  d="M7.4,2c1.5-2.7,5.4-2.7,6.9,0l6.9,11.9c1.5,2.7-0.4,6-3.5,6H4c-3.1,0-5-3.3-3.5-6L7.4,2z"
                />
                <path
                  class="st1"
                  style="fill-rule: evenodd; clip-rule: evenodd; fill: #3f4141"
                  d="M11,9.3c0.9,0,1.6,0.7,1.6,1.6v4.6c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6v-4.6C9.4,10,10.1,9.3,11,9.3z
                                                                            	"
                />
                <path
                  class="st1"
                  style="fill-rule: evenodd; clip-rule: evenodd; fill: #3f4141"
                  d="M11,8.3c1,0,1.9-0.9,1.9-1.9c0-1-0.9-1.9-1.9-1.9c-1,0-1.9,0.9-1.9,1.9C9.1,7.5,10,8.3,11,8.3z"
                />
              </svg>
              {{ $t("m.server.limit") }}
            </div>
            <div class="text-with-icon">
              <svg
                version="1.1"
                id="图层_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 22 22"
                style="
                  enable-background: new 0 0 22 22;
                  height: 22px;
                  width: 22px;
                  fill-rule: evenodd;
                  clip-rule: evenodd;
                  fill: #f46d5b;
                "
                xml:space="preserve"
              >
                <path
                  class="st0"
                  d="M11,0C4.9,0,0,4.9,0,11c0,6.1,4.9,11,11,11c6.1,0,11-4.9,11-11C22,4.9,17.1,0,11,0z M9.4,6.1
                                                                            	c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6v4.6c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6V6.1z M11,17.1
                                                                            	c-1,0-1.9-0.9-1.9-1.9c0-1,0.9-1.9,1.9-1.9c1,0,1.9,0.9,1.9,1.9C12.9,16.2,12,17.1,11,17.1z"
                /></svg
              >{{ $t("m.server.bigerror") }}
            </div>
          </div>
          <div class="status-box">
            <div
              class="title"
              :class="{ zh: $i18n.locale == 'zh', en: $i18n.locale != 'zh' }"
            >
              <span> {{ $t("m.server.serve") }}</span>

              <div class="status-select">
                <el-select
                  v-if="$i18n.locale == 'en'"
                  v-model="apiUrl"
                  :popper-append-to-body="false"
                  ref="statusSelect"
                  @change="getData()"
                >
                  <el-option
                    v-for="(item, index) in statusData"
                    :key="index"
                    :label="item.name"
                    :value="item.url"
                  >
                  </el-option>
                </el-select>
                <div class="tag-box" v-else>
                  {{ "简体中文节点" }}
                </div>
                <!-- <el-select
                  v-else
                  class="zh"
                  v-model="apiUrl"
                  :popper-append-to-body="false"
                  disabled
                >
                  <el-option
                    v-for="(item, index) in statusDataZh"
                    :key="index"
                    :label="item.name"
                    :value="item.url"
                  >
                  </el-option> 
                </el-select>-->
              </div>
            </div>

            <div class="table">
              <el-skeleton style="width: 100%" :loading="data == ''" animated>
                <template slot="template">
                  <div class="li loading" v-for="index in 7" :key="index">
                    <el-skeleton-item class="img" variant="image" />
                    <el-skeleton-item
                      class="txt"
                      variant="text"
                      style="width: 20%"
                    />
                  </div>
                </template>
                <template>
                  <div class="li" v-for="(li, index) in data" :key="index">
                    <div v-if="li == 0">
                      <div class="text-with-icon">
                        <svg
                          version="1.1"
                          id="图层_1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          x="0px"
                          y="0px"
                          viewBox="0 0 22 22"
                          style="
                            enable-background: new 0 0 22 22;
                            fill-rule: evenodd;
                            clip-rule: evenodd;
                            fill: #77c64b;
                            width: 22px;
                          "
                          xml:space="preserve"
                        >
                          <path
                            class="st0"
                            d="M11,0C4.9,0,0,4.9,0,11c0,6.1,4.9,11,11,11s11-4.9,11-11C22,4.9,17.1,0,11,0z M15.8,10L11,14.8
                                                                            	c0,0-0.1,0.1-0.1,0.1c-0.3,0.3-0.7,0.5-1.1,0.5c-0.4,0-0.8-0.2-1.1-0.5c0,0-0.1-0.1-0.1-0.1l-2.5-2.5c-0.6-0.6-0.6-1.6,0-2.2
                                                                            	c0.6-0.6,1.6-0.6,2.2,0l1.5,1.5l3.8-3.8c0.6-0.6,1.6-0.6,2.2,0C16.4,8.4,16.4,9.4,15.8,10z"
                          />
                        </svg>
                        {{ translate(index) }}
                      </div>
                    </div>
                    <div v-if="li == 1">
                      <div class="text-with-icon">
                        <svg
                          version="1.1"
                          id="图层_1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          x="0px"
                          y="0px"
                          viewBox="0 0 21.8 19.9"
                          style="
                            enable-background: new 0 0 21.8 19.9;
                            width: 22px;
                          "
                          xml:space="preserve"
                        >
                          <path
                            class="st0"
                            style="fill: #ffb940"
                            d="M7.4,2c1.5-2.7,5.4-2.7,6.9,0l6.9,11.9c1.5,2.7-0.4,6-3.5,6H4c-3.1,0-5-3.3-3.5-6L7.4,2z"
                          />
                          <path
                            class="st1"
                            style="
                              fill-rule: evenodd;
                              clip-rule: evenodd;
                              fill: #3f4141;
                            "
                            d="M11,9.3c0.9,0,1.6,0.7,1.6,1.6v4.6c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6v-4.6C9.4,10,10.1,9.3,11,9.3z
                                                                            	"
                          />
                          <path
                            class="st1"
                            style="
                              fill-rule: evenodd;
                              clip-rule: evenodd;
                              fill: #3f4141;
                            "
                            d="M11,8.3c1,0,1.9-0.9,1.9-1.9c0-1-0.9-1.9-1.9-1.9c-1,0-1.9,0.9-1.9,1.9C9.1,7.5,10,8.3,11,8.3z"
                          />
                        </svg>
                        {{ translate(index) }}
                      </div>
                    </div>
                    <div v-if="li == 2">
                      <div class="text-with-icon">
                        <svg
                          version="1.1"
                          id="图层_1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          x="0px"
                          y="0px"
                          viewBox="0 0 22 22"
                          style="
                            enable-background: new 0 0 22 22;
                            width: 22px;
                            fill-rule: evenodd;
                            clip-rule: evenodd;
                            fill: #f46d5b;
                          "
                          xml:space="preserve"
                        >
                          <path
                            class="st0"
                            d="M11,0C4.9,0,0,4.9,0,11c0,6.1,4.9,11,11,11c6.1,0,11-4.9,11-11C22,4.9,17.1,0,11,0z M9.4,6.1
                                                                            	c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6v4.6c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6V6.1z M11,17.1
                                                                            	c-1,0-1.9-0.9-1.9-1.9c0-1,0.9-1.9,1.9-1.9c1,0,1.9,0.9,1.9,1.9C12.9,16.2,12,17.1,11,17.1z"
                          />
                        </svg>
                        {{ translate(index) }}
                      </div>
                    </div>
                  </div>
                </template>
              </el-skeleton>
            </div>
          </div>
        </div>
        <div class="tab-box">
          <SideTap
            class="win article"
            :topAlert="$t('m.server.article')"
            :title="this.$route.hash"
            :family="`'Nunito-Bold','HYZhengYuan-65W'`"
            :size="16"
            :titleSize="20"
            :keys="tags"
            :pad="8"
            :lheight="28"
            :padding="15"
            :fullHeight="'auto'"
            :radius="'18px'"
            :marginBottom="40"
            :width="'100%'"
            :notActive="true"
          >
          </SideTap>
          <SideTap
            class="win"
            :topAlert="$t('m.server.report')"
            :family="`'Nunito-Bold','HYZhengYuan-65W'`"
            :size="16"
            :titleSize="20"
            :pad="5"
            :alertText="$t('m.server.detail')"
            :marginBottom="40"
            :alert="true"
            :alertBtn="$t('m.server.repbtn')"
            :padding="15"
            :width="'100%'"
            :lheight="'28'"
            :fullHeight="'auto'"
          >
          </SideTap>
          <SideTap
            class="win"
            :topAlert="$t('m.server.help')"
            :family="`'Nunito-Bold','HYZhengYuan-65W'`"
            :size="16"
            :titleSize="20"
            :pad="5"
            :alertText="$t('m.server.detail1')"
            :width="'100%'"
            :alert="true"
            :padding="15"
            :marginBottom="40"
            :alertBtn="$t('m.server.repbtn1')"
            :fullHeight="'auto'"
            :lheight="'28'"
          >
          </SideTap>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Featured from "../components/Featured.vue";
import SideTap from "../components/SideTap.vue";
import BannerSearch from "../components/BannerSearch.vue";
import Loading from "../components/Loading.vue";
import i18n from "../lang";

export default {
  components: { Featured, SideTap, BannerSearch, Loading },
  inject: ["reload"],
  data() {
    return {
      list: [],
      services: "",
      sucess: false,
      description: "",
      index: "",
      servicesData: [
        "Announcement",
        "Room",
        "Matching",
        "Login",
        "OfficialSite",
        "Store",
        "FriendChat",
      ],
      statusData: [
        {
          url: "https://support.partyanimals.com/service-status/ap-northeast-1.json",
          name: "Asia",
        },
        {
          url: "https://support.partyanimals.com/service-status/us-east-1.json",
          name: "North America",
        },
        {
          url: "https://support.partyanimals.com/service-status/eu-central-1.json",
          name: "Europe",
        },
        {
          url: "https://support.partyanimals.com/service-status/ap-southeast-2.json",
          name: "Oceania",
        },
        {
          url: "https://support.partyanimals.com/service-status/sa-east-1.json",
          name: "South America",
        },
      ],
      statusDataZh: [
        {
          url: "https://support.partyanimals.cn/service-status/cn-northwest-1.json",
          name: "简体中文节点",
        },
      ],
      data: "",
      tags: [],
      Report: "",
      alert: "",
      time: "",
      code: 0,
      Report: false,
      apiUrl: "https://support.partyanimals.com/service-status/us-east-1.json",
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    if (i18n.locale == "zh") {
      this.servicesData = [
        { name: "公告系统", value: "Announcement" },
        { name: "自定义房间", value: "Room" },
        { name: "快速游戏", value: "Matching" },
        { name: "登录", value: "Login" },
        { name: "官方网站", value: "OfficialSite" },
        { name: "商店", value: "Store" },
        { name: "好友与聊天", value: "FriendChat" },
      ];
    } else {
      this.servicesData = [
        { name: "Announcement", value: "Announcement" },
        { name: "Custom Game", value: "Room" },
        { name: "Quick Match", value: "Matching" },
        { name: "Login", value: "Login" },
        { name: "Official Website", value: "OfficialSite" },
        { name: "Item Shop", value: "Store" },
        { name: "Friends & Chat", value: "FriendChat" },
      ];
    }
    this.waitForUdeskReady(() => {
      this.getData();
    });
    var count = 0;
    let timer = setInterval(() => {
      count++;
      if (count >= 50) {
        clearInterval(timer);
      }
      if (this.$store.state.InformationTwo != "") {
        this.$store.state.InformationTwo.posts.map((item) => {
          this.tags.push(item.title);
        });
        clearInterval(timer);
      }
    }, 200);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    document.body.classList.remove("no-scroll-serve");
    document.body.classList.remove("no-scroll");
  },
  watch: {
    $route(to, from) {
      if (to.name != from.name) {
        this.Report = false;
        // 关闭菜单时
        document.body.classList.remove("no-scroll-serve");
        document.body.classList.remove("no-scroll");
      }
    },
    Report(newValue, oldValue) {
      console.log("Report:", newValue, oldValue);
      // 在这里可以执行相应的操作
      if (newValue) {
        document.body.classList.add("no-scroll-serve");
      } else {
        document.body.classList.remove("no-scroll-serve");
      }
    },
   
  },
  methods: {
    hooseCustom() {
      //调用element-ui select组件blur方法
      //要包再timeout里面，直接调用不会关闭下拉框option
      setTimeout(() => {
        this.$refs.multiSelect.blur();
      }, 50);
    },

    translate(value) {
      console.log(value);

      switch (value) {
        case "announcement":
          return this.$t("m.server.Announcement");
        case "room":
          return this.$t("m.server.Room");
        case "matching":
          return this.$t("m.server.Matching");
        case "login":
          return this.$t("m.server.Login");
        case "officialSite":
          return this.$t("m.server.OfficialSite");
        case "store":
          return this.$t("m.server.Store");
        case "friendChat":
          return this.$t("m.server.FriendChat");
        default:
          break;
      }
    },
    closeSideMeau(e) {
      if (e.target == this.$refs.rightTab) {
        this.Report = false;
      }
      console.log();
    },
    handleResize() {
      const width = window.innerWidth;
      // if (width >= 1100) {
      //   this.Report = false;
      //   // 关闭菜单时
      //   document.body.classList.remove('no-scroll');
      // }
    },
    showMenu() {
      this.Report = !this.Report;
    },
    backHome() {
      this.Report = false;
      this.services = "";
      this.description = "";
      this.sucess = false;
    },
    closeRep() {
      this.Report = false;
      this.services = "";
      this.description = "";
    },
    post() {
      console.log(this.services);
      if (this.services != "") {
        this.alert = false;

        // 原始的GraphQL mutation字符串
        let mutationString = `mutation { reportServiceStateIssue (services: ["${this.services.toLowerCase()}"], description: ${JSON.stringify(
          this.description
        )}) {ok} }`;

        // 根据 this.services 的值替换部分字符串
        if (this.services.toLowerCase() === "officialsite") {
          mutationString = mutationString.replace(
            this.services.toLowerCase(),
            "officialSite"
          );
        } else if (this.services.toLowerCase() === "friendchat") {
          mutationString = mutationString.replace(
            this.services.toLowerCase(),
            "friendChat"
          );
        }
        this.$axios({
          method: "post",
          url: this.$backend.host,
          headers: {
            // jwt: getCookie('result_code'),
            "x-source": "Nemo",
          },
          data: {
            Query: mutationString,
          },
        }).then((res) => {
          console.log(res.data.result.reportServiceStateIssue.ok);
          if (res.data.result.reportServiceStateIssue.ok) {
            this.sucess = true;
            this.services = "";
            this.description = "";
          }
        });
      } else {
        this.alert = true;
      }
    },
    clickArt(v) {
      console.log(this.$store.state.InformationTwo);
      this.$store.state.InformationTwo.posts.map((item) => {
        if (v == item.title) {
          this.$router.push({
            path: "/article",
            query: {
              id: item.id,
            },
          });
        }
      });
    },
    click(v) {
      console.log(v);
      if (v == this.$t("m.server.repbtn") || v == "发送报告") {
        this.Report = true;
      }
      if (v == this.$t("m.server.repbtn1") || v == "创建工单") {
        if (this.$store.state.login) {
          this.$router.push("/tickets/new-tickets");
        } else {
          this.$router.push("/login");
        }
      }
    },
    getCookie(name) {
      var strcookie = document.cookie.replaceAll("result_code=;", ""); //获取cookie字符串

      var arrcookie = strcookie.split("; "); //分割
      //遍历匹配
      for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == name) {
          return arr[1];
        }
      }
      return "";
    },
    waitForUdeskReady(cb) {
      var u = this.$udesk;
      if (u.isReady == true) {
        cb();
        return;
      }

      function wait() {
        if (u.isReady == true) {
          cb();
        } else {
          setTimeout(wait, 250);
        }
      }
      wait();
    },
    getData() {
      this.data = "";
      // 判断并设置 preferredLang
      if (this.$i18n.locale == "zh") {
        this.apiUrl =
          "https://support.partyanimals.cn/service-status/cn-northwest-1.json";
      }
      setTimeout(() => {
        this.$axios({
          method: "get",
          url: this.apiUrl + "?ts=" + new Date().getTime(),
        })
          .then((res) => {
            console.log(res);
            this.data = res.data;
            // console.log(...res.data.result.serviceStatus);
            this.time = Date.parse(new Date());

            document.cookie = "service_timer=" + Date.parse(new Date());
            document.cookie = "service_data=" + JSON.stringify(res.data);

            for (const key in this.data) {
              if (this.data.hasOwnProperty(key)) {
                const value = this.data[key];

                if (value === 2) {
                  this.code = Math.max(this.code, 2);
                } else if (value === 1) {
                  this.code = Math.max(this.code, 1);
                }

                console.log("Key:", key);
                console.log("Value:", value);
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
        this.$refs.statusSelect.blur();
      }, 50);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/serve.scss";
</style>
